export const buildPaginationHead = ({
  path,
  currentPage,
  isLastPage,
}: {
  path: string;
  currentPage: number;
  isLastPage: boolean;
}) => {
  const basePath = path.replace(/\/$/, '').replace(/\/page\/\d+$/, '');
  const pagePath = (page: number) =>
    page === 1 ? basePath : `${basePath}/page/${page}`;

  return {
    prevPath: currentPage > 1 ? pagePath(currentPage - 1) : undefined,
    nextPath: isLastPage ? undefined : pagePath(currentPage + 1),
  };
};
